import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import fileReducer from "./slices/fileSlice";
import broadcastMessageReducer from "./slices/broadcastMessageSlice";
import teamSlice from "./slices/teamSlice";
import participantSlice from "./slices/participantSlice";
import chatReducer from "./slices/chatSlice";
import pollReducer from './slices/pollSlice';
import contestReducer from './slices/contestSlice';
import eventReducer from './slices/eventSlice';
import scheduleReducer from "./slices/scheduleSlice";
import registrationReducer from "./slices/registrationSlice";
import invitesReducer from './slices/invitesSlice';
import stationGroupsReducer from './slices/stationGroupsSlice';
import stationsReducer from '../Pages/Dashboard/Sessions/modules/stationsSlice';
import sessionsReducer from '../Pages/Dashboard/Sessions/modules/sessionsSlice';
import appsReducer from '../Pages/Dashboard/Sessions/modules/appsSlice';
import mappingsReducer from './slices/mappingsSlice';
import appReducer from "./slices/appSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    file: fileReducer,
    broadcastMessage: broadcastMessageReducer,
    team: teamSlice,
    participant: participantSlice,
    chat: chatReducer,
    poll: pollReducer,
    event: eventReducer,
    contest: contestReducer,
    schedule: scheduleReducer,
    registration: registrationReducer,
    broadcastMessage: broadcastMessageReducer,
    invites: invitesReducer,
    stationGroups: stationGroupsReducer,
    stations: stationsReducer,
    sessions: sessionsReducer,
    apps: appsReducer,
    mappings: mappingsReducer,
    app: appReducer    // apps from the stats service
  },
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware({
    serializableCheck: {
      // Ignore ALL actions from these slices
      ignoredActions: [
        /^chat\//,
        /^contest\//,
        /^polls\//,
        /^schedule\//,
        /^auth\//
      ],
      // Ignore ALL date-related paths in the state
      ignoredPaths: [
        /\.events\./i,    // Any path containing '.events.'
        /\.startDate$/i,  // Any path ending with 'startDate'
        /\.endDate$/i,    // Any path ending with 'endDate'
        /\.start$/i,      // Any path ending with 'start'
        /\.end$/i,        // Any path ending with 'end'
        /\.date$/i,       // Any path ending with 'date'
        /\.currentDate$/i // Specific path
      ]
    },
  }),
});

export default store;
